// Plain mutable holder for the active thread revision (read-revision-as-context).
//
// A LEAF module (imports nothing) so the openapi client interceptor can read the
// active `thread/<id>` synchronously without importing the release-store —
// importing it there would create a module-load cycle:
//   client → release-store → lib/openapi (api = useServices() at import) → client
// which leaves `useClient` undefined.
//
// The release-store keeps `current` in sync with its `activeRevision` (only
// `thread/<id>` values; releases / working copy clear it back to null). The
// client sends it as the `x-thread-revision` header so the backend resolves
// reads at that branch (see infrastructure._read_thread_revision_header).
export const threadRevisionContext: { current: string | null } = {
    current: null,
};
